class ResponsiveVideo extends HTMLElement {
  constructor() {
    super();
    this.MOBILE_BREAKPOINT = 768;
    this.resizeTimer = null;
  }

  connectedCallback() {
    this.handleResponsiveVideo();
    this.setupResizeListener();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }

  isMobile() {
    return window.innerWidth < this.MOBILE_BREAKPOINT;
  }

  loadVideo() {
    const video = this.querySelector('video');
    if (!video) return;

    const sources = video.querySelectorAll('source[data-src]');
    if (sources.length === 0) return;

    sources.forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.load();
    video.play().catch(() => {
      // Autoplay failed, user interaction required
    });
  }

  unloadVideo() {
    const video = this.querySelector('video');
    if (!video) return;

    video.pause();

    const sources = video.querySelectorAll('source');
    sources.forEach((source) => {
      if (source.src) {
        source.removeAttribute('src');
      }
    });

    video.removeAttribute('src');
    video.load();
  }

  handleResponsiveVideo() {
    const video = this.querySelector('video');
    if (!video) return;

    const videoType = video.dataset.videoType;
    const mobile = this.isMobile();
    const shouldLoad = (mobile && videoType === 'mobile') || (!mobile && videoType === 'desktop');

    if (shouldLoad) {
      const sources = video.querySelectorAll('source[data-src]');
      if (sources.length > 0) {
        this.loadVideo();
      } else {
        video.play().catch(() => {});
      }
    } else {
      this.unloadVideo();
    }
  }

  setupResizeListener() {
    this.handleResize = () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.handleResponsiveVideo();
      }, 250);
    };

    window.addEventListener('resize', this.handleResize);
  }
}

if (!customElements.get('responsive-video')) {
  customElements.define('responsive-video', ResponsiveVideo);
}
